module.exports = __webpack_public_path__ + "assets/svg/Icons/32/shift-offer-green-96ca88.svg";